import { Box, Typography, List, ListItem, ListItemButton, ListItemText, AppBar } from "@mui/material";
import { Link } from "react-router-dom";
import "../../styles/ServiceDetail.css";
import Navbar from "../../components/Navbar";

const services = [
  { name: "All Services", path: "/services" },
  { name: "Plant Supply", path: "/services/plant-supply" },
  { name: "Pots Supply", path: "/services/pots-supply" },
  { name: "Indoor Plant Setup", path: "/services/indoor-plant" },
  { name: "Kitchen Garden", path: "/services/kitchen-garden" },
  { name: "Garden Care & Maintenance", path: "/services/maintenance" },
  { name: "Artificial Lawn", path: "/services/artificial-lawn" },
  { name: "Vertical Garden", path: "/services/vertical-garden" },
  { name: "Drip Irrigation", path: "/services/drip-irrigation" },
];

const ServiceLayout = ({ title, children }) => {
  return (
    <>
    <AppBar position="fixed" elevation={6} sx={{ backgroundColor: "#2e7d32" }}>
        <Navbar />
      </AppBar>
    <main className="service-detail-page">
      {/* Sidebar */}
      <aside className="service-sidebar">
        <Typography variant="h6" className="sidebar-title">
          Our Services
        </Typography>
        <List>
          {services.map((s) => (
            <ListItem key={s.name} disablePadding>
              <ListItemButton component={Link} to={s.path}>
                <ListItemText primary={s.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </aside>

      {/* Content */}
      <section className="service-content">
        <Typography variant="h4" className="service-title">
          {title}
        </Typography>
        {children}
      </section>
    </main>
    </>
  );
};

export default ServiceLayout;
